import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, Megaphone, Users, MessageSquare, CalendarCheck, DollarSign, BarChart3 } from "lucide-react";

const flowSteps = [
  { icon: Megaphone, label: "Ads / Traffic" },
  { icon: Users, label: "Leads" },
  { icon: MessageSquare, label: "Instant Follow-up" },
  { icon: CalendarCheck, label: "Booking" },
  { icon: DollarSign, label: "Revenue" },
  { icon: BarChart3, label: "Optimization" },
];

export const HowItWorksHero = () => {
  return (
    <section className="py-24 px-4 bg-gradient-to-b from-secondary to-background">
      <div className="max-w-5xl mx-auto text-center">
        <motion.h1
          className="text-4xl md:text-6xl font-bold text-foreground mb-6 leading-tight"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          How We Turn Leads Into Booked Customers
        </motion.h1>
        <motion.p
          className="text-lg md:text-xl text-muted-foreground max-w-3xl mx-auto mb-12"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.15 }}
        >
          We don't just generate leads—we build systems that capture, nurture, and convert them into paying customers.
        </motion.p>

        {/* Visual Flow */}
        <motion.div
          className="flex flex-wrap items-center justify-center gap-2 md:gap-4 mb-14"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          {flowSteps.map((step, i) => (
            <div key={step.label} className="flex items-center gap-2 md:gap-4">
              <div className="flex flex-col items-center gap-2">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary/10 flex items-center justify-center">
                  <step.icon className="w-7 h-7 md:w-8 md:h-8 text-primary" />
                </div>
                <span className="text-xs md:text-sm font-medium text-foreground">{step.label}</span>
              </div>
              {i < flowSteps.length - 1 && (
                <ArrowRight className="w-5 h-5 text-muted-foreground mt-[-20px]" />
              )}
            </div>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.45 }}
        >
          <Link to="/demo">
            <Button size="lg" className="text-base px-8 py-6">
              Get a Free Audit
            </Button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};
